import React from "react";
import { EventType } from "../types";
import EventsGrid from "../EventsGrid";

interface EventsSectionProps {
  events: EventType[];
  setActiveShareModalEventId: (id: number) => void;
  setMarkUploadCompletePopup: (id: number) => void;
  albumLoadingId: number | null;
  showActionTooltip: (id: number | null, title: string, type: string) => void;
  handleEventClickWithNavigation: (event: EventType) => void;
  setPrivacyPopupId: (id: number) => void;
}

const Events: React.FC<EventsSectionProps> = ({
  events,
  albumLoadingId,
  showActionTooltip,
  setActiveShareModalEventId,
  setMarkUploadCompletePopup,
  handleEventClickWithNavigation,
  setPrivacyPopupId
}) => {
  return (
    <div className="ws-events-section">
      <div className="ws-library-view-heading folders-heading">Events</div>
      <EventsGrid
        events={events}
        albumLoadingId={albumLoadingId}
        showActionTooltip={showActionTooltip}
        handleEventClickWithNavigation={handleEventClickWithNavigation}
        setActiveShareModalEventId={setActiveShareModalEventId}
        setMarkUploadCompletePopup={setMarkUploadCompletePopup}
        source="nested-events"
        setPrivacyPopupId={setPrivacyPopupId}
      />
    </div>
  );
};

export default Events;
